import { lazy, Suspense } from 'react';
import LoadingSpinner from '../../../components/LoadingSpinner';

const QuoteForm = lazy(() => import('../quote/QuoteForm'));

const NewRequest = () => {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><LoadingSpinner message="Loading..." /></div>}>
      <QuoteForm />
    </Suspense>
  );
};

export default NewRequest; 